import logger from './logger';
/**
 * Loads the enabled stream effects.
 *
 * @param {Object} store - The Redux store.
 * @returns {Promise} - A Promise which resolves when all effects are created.
 */
export default function loadEffects(store) {
    const start = window.performance.now();
    return Promise.resolve([]).then(effectsArray => {
        const end = window.performance.now();
        logger.debug(`(TIME) loadEffects() start=${start}, end=${end}, time=${end - start}`);
        return effectsArray;
    });
}
